
import { StyleValue } from '@/shared/app/model/StyleValue';
import Base from '@/shared/app/ui/Base.vue';
import Component from 'vue-class-component';

@Component
export default class Box extends Base {
  get slotKeyName() {
    return Object.keys(this.$scopedSlots)[0];
  }

  get style() {
    const style: StyleValue = {
      zIndex: '0',
      top: '0',
      left: '0',
      bottom: '0',
      right: '0',
      padding: '0',
      margin: '0',
      border: 'none',
      borderWidth: '0',
      borderRadius: '0',
      borderStyle: 'solid',
    };
    if (this.config.padding) style.padding = this.config.padding.toString();
    if (this.config.margin) style.margin = this.config.margin.toString();
    if (this.config.border) {
      const borderColor =
        this.config.borderColor?.toString() || this.theme.secondaryColor;
      style.border = `1px solid ${borderColor}`;
      if (this.config.borderWidth)
        style.borderWidth = this.config.borderWidth.toString();
    }
    if (this.config.borderRadius)
      style.borderRadius = this.config.borderRadius.toString();
    if (this.config.borderStyle)
      style.borderStyle = this.config.borderStyle.toString();
    if (this.config.position) {
      style.position = this.config.position.toString() as 'relative';
      if (this.config.zIndex) style.zIndex = this.config.top.toString();
      else style.zIndex = '1';
      if (this.config.top) style.top = this.config.top.toString();
      if (this.config.left) style.left = this.config.left.toString();
      if (this.config.bottom) style.bottom = this.config.bottom.toString();
      if (this.config.right) style.right = this.config.right.toString();
    }
    if (this.config.backgroundColorValue)
      style.backgroundColor = this.config.backgroundColorValue.toString();
    return style;
  }

  get backgroundStyle() {
    const backgroundImageKey =
      (this.config.backgroundImageKey &&
        this.config.backgroundImageKey.toString()) ||
      'image1';
    const o: StyleValue = {
      display: this.config.background ? 'block' : 'none',
      backgroundColor: this.config.backgroundColor
        ? this.theme[String(this.config.backgroundColor)]?.toString()
        : this.config.backgroundColorValue?.toString() ||
        this.theme.secondaryColor?.toString(),
      backgroundImage: this.config.backgroundImage
        ? `url(${this.theme[backgroundImageKey]})`
        : '',
      backgroundRepeat: this.config.backgroundRepeat?.toString() || 'no-repeat',
      backgroundSize: this.config.backgroundSize?.toString() || 'cover',
      backgroundPosition: this.config.backgroundPosition?.toString() || '0% 0%',
    };
    if (this.config.backgroundImage && this.config.backgroundImagePath) {
      o.backgroundImage = `url(${this.config.backgroundImagePath})`;
    }
    if (this.config.backgroundPadding) {
      o.top = this.config.backgroundPadding.toString();
      o.right = this.config.backgroundPadding.toString();
      o.bottom = this.config.backgroundPadding.toString();
      o.left = this.config.backgroundPadding.toString();
    }
    return o;
  }

  get sizerStyle() {
    const style = {
      'padding-top': '0',
    };
    if (this.config.keepAspectRatioPaddingTop) {
      style['padding-top'] = this.config.keepAspectRatioPaddingTop.toString();
    }
    return style;
  }

  get shadowStyle(): StyleValue {
    const shadowSize = this.config.shadowSize
      ? this.config.shadowSize?.toString()
      : '0.3rem';
    return {
      display: this.config.shadow ? 'block' : 'none',
      'background-color': this.config.shadowColor
        ? this.theme[String(this.config.shadowColor)]?.toString()
        : this.theme.color1?.toString(),
      top: shadowSize,
      left: shadowSize,
    };
  }

  get itemsCenter() {
    return this.config.itemsCenter === true;
  }
}
